const DynamicAnchor = (anchorHref, paramData) => {
    // prepare dynamic links
    if (anchorHref && anchorHref.includes('{') && anchorHref.includes('?')) {
      let anchorLinkArr = anchorHref.split('?');
      const params = new URLSearchParams(anchorLinkArr[1]);
  
      for (const param of params) {
        if (param[1].includes('{')) {
          params.set(param[0], paramData[param[0]] ? paramData[param[0]] : '');
        }
      }
  
      return anchorLinkArr[0] + '?' + params.toString();
    }
  
    return anchorHref;
  };
  
  export default DynamicAnchor;
  